import { Fragment, useEffect, useState, createElement } from 'react'
import DataTable from 'react-data-table-component'
import { Switch, Route } from 'react-router'
import { Link } from 'react-router-dom'
import { FaChevronLeft } from 'react-icons/fa'
import { Menu, MenuDivider, MenuItem } from '@szhsin/react-menu'
import QrReader from 'react-qr-reader'
import Modal from 'react-responsive-modal'
import Swal from 'sweetalert2'

import toastr from '@modules/toastr'
import Loader from '@shared/loader'
import StateStore from '@helpers/state-store'
import { extractKeys } from '@helpers/objects'
import { fullName } from '@modules/form-wizard/utils'
import ApplicationNotes from '@modules/form-wizard/notes'
// import { getUploadPath } from '@modules/form-wizard/utils'

import UpskillBahamas from '../upskill-bahamas'
import BatchFormView from '../../../modules/form-wizard/form-batch-view'

import CsvDownloader  from 'use-csv-downloader'
const downloadCSV = CsvDownloader({});

const MODAL = {
  MODE: 'MODE',
  VIA_LICENCE_NUMBER: 'VLN',
  VIA_QR_CODE: 'VQR',
}

const SERVICES = {
  UPSKILL_BAHAMAS: {
    resource: '/moe/up_skill_bahamas',
    form_key: 'up_skill_bahama',
    path: 'upskill-bahamas-programme',
    label: 'UpSKill Bahamas Programme',
    form_type: 'Opm::UpSkillBahamas',
    serviceType: record => {
      return 'UpSKill Bahamas Programme'
    }
  }
}

const UpSkillBatchApprovals = props => {
  const endDateEvent = new Date();
  endDateEvent.setDate(endDateEvent.getDate() + 1)

  const [formSelected, setFormSelected] = useState(null)
  const [service, setService] = useState(null)
  const [selected, setSelected] = useState([])
  const [loading, setLoading] = useState(false)
  const [clear] = useState(false)
  const [data, setData] = useState([])
  const [active, setActive] = useState({})
  const [modal, setModal] = useState([])
  // const [focusArea, setFocusArea] = useState(null)
  // const [formStatus, setFormStatus] = useState('')
  const [showDateModal, setDateModal] = useState(false);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState(endDateEvent.toISOString().split('T')[0])
  const [params, setParams] = StateStore({
    status: 'pending',
    page: 1,
    per_page: 20,
  })

  const BASE_URL = props.match.url
  const { history } = props

  const generateCSV = () => {
    const csv = data.map(({ user, ...rest }) => ({
      ...rest,
      ...extractKeys(
        user,
        'first_name:applicant_first_name',
        'middle_name:applicant_middle_name',
        'last_name:applicant_last_name',
        'gender:applicant_gender',
        'email:applicant_email',
        'NIB:applicant_NIB',
        'additional_phone_number:applicant_phone_number',
        'date_of_birth:applicant_date_of_birth',
        'country_of_citizenship:applicant_country_of_citizenship',
        'country_of_residence:applicant_country_of_residence',
      ),
      ...extractKeys(
        user?.home_address,
        'island:applicant_home_island',
        'country:applicant_home_country',
      ),
    }))
    let today = new Date().toISOString().split('T')[0];

    console.log(csv);
    downloadCSV(csv, `${service?.label}-${today}.csv`);
  };

  const csvDownloaderMenu =
    !data?.length ? null :
      (
        <div className='flex items-center space-x-4'>
        <button className='btn' onClick={() => generateCSV()}>
          <i className='fas fa-download' />
          <span className='text-gray-700'> Download CSV</span>
        </button>
      </div>
      )

  useEffect(() => {
    service && fetchRecords()
  }, [service, params.page, params.per_page])

  const changeService = ev => {
    const v = ev.target.value

    if (!v) {
      setService(null)
      return
    }

    setFormSelected(null);
    setService({ key: v, ...SERVICES[v] })
  }

  const fetchRecords = async () => {
    setLoading(true)

    try {
      const { data } = await $app.axios.get(service.resource, { params })

      setData(data.records)
      setParams(data.records_params)
    } catch (err) {
      console.error(err)
      toastr.error('Error', (err?.response?.data?.error || err?.response?.data?.message) || 'There has been an error with fetching the records')
    } finally {
      setLoading(false)
    }
  }

  const filterDate = () => () => {
      const currParams = params;
      currParams['start_date'] = startDate;
      currParams['end_date'] = endDate;
      setParams(currParams);
      fetchRecords();

      return setDateModal(false);
  }

  const filterStatus = () => async () => {
    const { value: status } = await Swal.fire({
      title: 'Select status',
      input: 'select',
      inputOptions: {
        none: 'None',
        pending: 'Pending',
        processing: 'Processing',
        denied: 'Denied',
        approved: 'Approved',
      },
      inputPlaceholder: 'Select a filter',
      showCancelButton: true,
    })
    
    if (status) {
      const currParams = params;
      currParams['status'] = status;
      if (status === 'none') delete currParams.status
      setParams(currParams);
      fetchRecords();
    }

      return
  }

  const filterIsland = () => async () => {
    const { value: island } = await Swal.fire({
      title: 'Select island',
      input: 'select',
      inputOptions: {
        none: 'None',
        'new providence': 'New Providence',
        'grand bahama': 'Grand Bahama',
        'abaco': 'Abaco',
        'andros': 'Andros',
        'berry islands': 'Berry Islands',
        'bimini': 'Bimini',
        'cat island': 'Cat Island',
        'crooked island': 'Crooked Island',
        'exuma': 'Exuma',
        'harbour island': 'Harbour Island',
        'inagua': 'Inagua',
        'long island': 'Long Island',
        'mayaguana': 'Mayaguana',
        'ragged island': 'Ragged Island',
        'rum cay': 'Rum Cay',
        'san salvador': 'San Salvador',
      },
      inputPlaceholder: 'Select a filter',
      showCancelButton: true,
    })
    
    if (island) {
      const currParams = params;
      currParams['place_of_residence'] = island;
      if (island === 'none') delete currParams.place_of_residence
      setParams(currParams);
      fetchRecords();
    }

      return
  }

  const approve = (selector) => async () => {
    // Single Record Update
    if (selector?.user) {
      const { isDismissed } = await Swal.fire({
        icon: 'question',
        title: 'Approve Application',
        html: `
          Are you sure you want to approve this application for
          <strong>${fullName(selector.user, 'initial')}</strong>?
        `,
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve',
      })

      if (isDismissed) return
      setLoading(true)

      try {
        await $app.axios.put(service.resource + '/update_application', {
          [service.form_key]: {
            form_num: selector.form_num,
            application_decision: 'approved'
          },
        })

        toastr.success('Success', 'Application successfully updated')
        setActive({})
        fetchRecords()
      } catch (error) {
        setLoading(false)
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
        )
      }

      return
    }

    // Batch Updates
    const affectingAll = selector === data
    const { isDismissed } = await Swal.fire({
      icon: 'question',
      title: `Approve ${affectingAll ? 'All' : 'Selected'} Applications`,
      html: affectingAll
        ? `
          Are you sure that you want to approve
          all of the applications on the current page?
        `
        : `
          Are you sure you want to approve
          the ${selected.length} selected application(s)?
        `,
      showCancelButton: true,
      confirmButtonText: 'Yes, Approve All',
    })

    if (isDismissed) return
    setLoading(true)

    try {
      const form_ids = selector.map(f => f.id)

      await $app.axios.put(service.resource + '/update_application_batch', {
        [service.form_key]: {
          form_ids,
          application_decision: 'approved'
        }
      })

      toastr.success('Success', 'Applications successfully updated')
      fetchRecords()
    } catch (error) {
      setLoading(false)
      console.error(error)
      Swal.fire(
        'Oops...',
        'There has been an error with processing the affected applications',
        'error'
      )
    }
  }

  const deny = selector => async () => {
    // Single Record Update
    if (selector?.user) {
      const { isConfirmed } = await Swal.fire({
        icon: 'question',
        title: 'Deny Application',
        html: `
          Are you sure you want to approve this application for
          <strong>${fullName(selector.user, 'initial')}</strong>?
        `,
        showCancelButton: true,
        confirmButtonText: 'Yes, Deny',
      })

      if (!isConfirmed) return
      setLoading(true)

      try {
        await $app.axios.put(service.resource + '/update_application', {
          [service.form_key]: {
            form_num: selector.form_num,
            application_decision: 'denied',
          },
        })

        toastr.success('Success', 'Application successfully updated')
        setActive({})
        fetchRecords()
      } catch (error) {
        setLoading(false)
        console.error(error)
        Swal.fire(
          'Oops...',
          'There has been an error with processing your application',
          'error'
          )
        }
        
      return
    }

    // Batch Updates
    const affectingAll = selector === data
    const { isDismissed } = await Swal.fire({
      icon: 'question',
      title: `Deny ${affectingAll ? 'All' : 'Selected'} Applications`,
      html: affectingAll
        ? `
          Are you sure that you want to deny all
          of the applications on the current page?
        `
        : `
          Are you sure you want to deny
          the ${selected.length} selected application(s)?
        `,
      showCancelButton: true,
      confirmButtonText: 'Yes, Deny All',
    })

    if (isDismissed) return
    setLoading(true)

    try {
      const form_ids = selector.map(f => f.id)

      await $app.axios.put(service.resource + '/update_application_batch', {
        [service.form_key]: {
          form_ids,
          application_decision: 'denied'
        }
      })

      toastr.success('Success', 'Applications successfully updated')
      fetchRecords()
    } catch (error) {
      setLoading(false)
      console.error(error)
      Swal.fire(
        'Oops...',
        'There has been an error with processing the affected applications',
        'error'
      )
    }
  }

  const viewRecord = record => {
    // console.log(record);
    // console.log(service);
    // service?.key == 'SECURITY_LICENCES' && console.log(service.path(record));
    setFormSelected(record);

    // const to = typeof service.path == 'function'
    //   ? service.path(record)
    //   : service.path

    // history.push(sublink(to), { view: record })
  }

  const writeNote = async record => {
    if (!record.notes?.length) record.notes = []

    const { value: text } = await Swal.fire({
      input: 'textarea',
      title: 'Add Note',
      inputAttributes: {
        autocorrect: 'on',
      },
      showCancelButton: true,
    })

    if (!text) return

    try {
      const { data } = await $app.axios.post('/services/notes/add_note', {
        note: {
          note_type: 'note',
          internal_view_only: true,
          notable_type: service.form_type,
          notable_id: record.id,
          text,
        },
      })

      record.notes.push(data.note)

      Swal.fire({
        icon: 'success',
        toast: 'true',
        text: 'Note successfully created',
        timer: 5000,
        position: 'top-end',
        showConfirmButton: false,
      })
    } catch (err) {
      console.error(err)
      
      Swal.fire({
        icon: 'error',
        toast: 'true',
        text: 'Failed to create note.',
        timer: 5000,
        position: 'top-end',
        showConfirmButton: false,
      })
    }
  }

  const showScanErrorMessage = async err => {
    console.error(err)
    setModal([])

    await Swal.fire(
      'Error',
      'There was a problem while scanning the QR code',
      'error'
    )
  }

  const getLicenceID = async action => {
    setModal([null, action])

    const { value, isDismissed } = await Swal.fire({
      input: 'text',
      text: 'Please enter the licence number you wish to ' + action,
      showCancelButton: true,
      cancelButtonText: 'Nevermind',
      confirmButtonText: action.capitalize()
    })

    if (isDismissed) return

    // TODO: Find licence by ID
    return value
  }

  const getLicenceViaQRCode = async code => {
    if (!code) return

  }

  const sublink = path => (BASE_URL + '/' + path).replace('//', '/')

  const Service = ({ Component: element, path = '', service = '' }) => (
    <Route
      path={sublink(path)}
      render={r => createElement(element, {
        ...r,
        service: $app.getService(service)
      })}
    />
  )

  const columns = [
    {
      name: 'Applicant',
      selector: row => `${row.user.last_name}, ${row.user.first_name}`.capitalize(),
      sortable: true,
    },
    {
      name: 'Island of Residence',
      selector: row => row.place_of_residence.capitalize(),
      sortable: true,
    },
    {
      name: 'Submitted Date',
      selector: row => row.created_at.slice(0, row.created_at.indexOf("T")),
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => {
        const status = row.application_decision // == 'pending' ? 'pending' : 'emailed'
        return (<span style={{textTransform: 'capitalize'}}>{status}</span>)
      },
      sortable: true,
    },
    // {
    //   name: 'Illustration Upload',
    //   omit: service?.key != 'SYMBOL_USE_PERMISSION',
    //   selector: row => {
    //     const data = row.image[1];
    //     const dataSplit = data.split('/');
    //     const isMissing = dataSplit[1] != 'system';
    //     let aRefLink;
    //     isMissing ? aRefLink = <span>N/A</span> : aRefLink = <a href={getUploadPath(data, true)} target="_blank" rel="noopener noreferrer">(Click To View)</a>;
        
    //     return aRefLink
    //   },
    //   sortable: true,
    // },
    {
      name: 'Actions',
      right: true,
      cell: row => (
        <Menu
          menuButton={<span data-action>Actions</span>}
          transition
          portal
          arrow
        >
          <MenuItem onClick={() => viewRecord(row)}>
            View
          </MenuItem>
          <MenuDivider />
          <MenuItem style={{backgroundColor: 'red'}} onClick={approve(row)}>
            Approve
          </MenuItem>
          <MenuItem onClick={deny(row)}>
            Deny
          </MenuItem>
          <MenuItem onClick={() => setActive(row)}>
            View Notes
          </MenuItem>
          <MenuItem onClick={() => writeNote(row)}>
            Create Note
          </MenuItem>
        </Menu>
      ),
    }
  ]

  const colors = [
    {
      style: { backgroundColor: '#0E33' },
      when: row => row.application_decision == 'approved'
    },
    {
      style: { backgroundColor: '#FFBF0044' },
      when: row => row.application_decision == 'pending'
    },
    {
      style: { backgroundColor: '#FFBF0044' },
      when: row => row.application_decision == 'denied'
    },
  ]

  const allFields = [
    {
      name: 'details',
      label: 'Details',
      type: 'heading',
    },
    {
      name: 'i_am_applicant',
      label: 'Who are you filling out this form for?',
      type: 'select',
      view: {
        true: 'I am applying for myself',
        false: 'I am applying on behalf of a minor (as their legal guardian)',
      }
    },

    '::Section 1: Basic Details',
      {
      heading: `
          Since you are applying on behalf of a minor, please complete all questions 
          in this form as if you were them.
          That is, please answer questions on their behalf
      `,
      view: false,
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
    },
    {
      name: 'first_name',
      label: 'Minor\'s First Name',
      hint: 'Must match NIB card exactly.',
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
    },
    {
      name: 'last_name',
      label: 'Minor\'s Last Name',
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
    },
    {
      name: 'phone_number',
      label: 'i_am_applicant' ? 'Phone Number' : 'Guardian\'s Phone Number',
      type: 'phone',
    },

    {
      name: 'email',
      label: 'i_am_applicant' ? 'Email Address' : 'Guardian\'s Email Address',
      type: 'email',
    },
    {
      name: 'contact_preference',
      label: 'How do you prefer to be contacted?',
      type: 'select',
      format: 'capitalize',
    },

    '::SPACER',
    '::Section 2: Training Preference',
    {
      name: 'training_reason',
      label: 'What is your primary reason for wanting to undertake a training course?',
      type: 'select',
      format: 'capitalize',
    },

    {
      name: 'training_course_category',
      type: 'select',
      label: 'Please select ONE training course category that you would like to undertake',
      format: 'capitalize',
    },
    {
      name: 'training_course',
      type: 'select',
      label: 'Please select ONE training course that you would like to undertake',
      format: 'capitalize',
    },
    {
      name: 'training_course_category_2',
      type: 'select',
      label: 'In case the course selected previously is not available, please select a second training course category that you would like to undertake',
      format: 'capitalize',
    },
    {
      name: 'training_course_2',
      type: 'select',
      label: 'In case the course selected previously is not available, please select a second training course that you would like to undertake',
      format: 'capitalize',
    },

    '::SPACER',
    '::Section 3: Demographic Data',
    // Disable form if not Bahamian citizen
    {
      name: 'bahamian_citizen',
      type: 'select:bool',
      label: 'Is the minor a Bahamian citizen?',
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
    },
    {
      name: 'place_of_residence',
      label: 'i_am_applicant' ? 'What is your primary place of residence?' : 'What is the minor\'s primary place of residence?',
      type: 'select',
      format: 'capitalize',
    },
    {
      name: 'minor_date_of_birth',
      type: 'date',
      label: 'i_am_applicant' ? 'What is your date of birth?' : 'What is the minor\'s date of birth?',
      hint: 'Please enter in the format MM/DD/YYYY',
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
    },
    {
      name: 'minor_gender',
      type: 'select',
      label: 'i_am_applicant' ? 'What is your gender?' : 'What is the minor\'s gender?',
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
      format: 'capitalize',
    },
    {
      name: 'disability_status',
      type: 'select:bool',
      label: 'i_am_applicant' ? 'Do you have a disability?' : 'Does the minor have a disability?',
      hint: 'Note: This information is collected for statistical purposes only and will not affect your eligibility.',
    },
    {
      name: 'minor_nib_number',
      type: 'number',
      label: 'Minor\'s NIB Number',
      hide: {
        field_name: 'i_am_applicant',
        value: true,
      },
    },
    {
      name: 'employment_status',
      type: 'select',
      label: 'i_am_applicant' ? 'What is your current employment status?' : 'What is the minor\'s current employment status?',
      format: 'capitalize',
    },
    {
      name: 'unemployment_duration',
      type: 'select',
      label: 'For approximately how long have you been unemployed?',
      hide: {
        field_name: 'employment_status',
        value: 'unemployed',
        negate: true,
      },
    },
    {
      name: 'current_employer',
      label: 'Current employer',
      hide: [
        {
          field_name: 'employment_status',
          value: 'employed full time',
          negate: true,
        },
        {
          field_name: 'employment_status',
          value: 'employed part time',
          negate: true,
        },
        {
          field_name: 'employment_status',
          value: 'self-employed',
          negate: true,
        },
      ],
      format: 'capitalize',
    },
    {
      name: 'current_job_title',
      label: 'Current job title/role',
      hide: [
        {
          field_name: 'employment_status',
          value: 'employed full time',
          negate: true,
        },
        {
          field_name: 'employment_status',
          value: 'employed part time',
          negate: true,
        },
        {
          field_name: 'employment_status',
          value: 'self-employed',
          negate: true,
        },
      ],
      format: 'capitalize',
    },
    {
      name: 'sector_of_employment',
      label: 'What is your current sector of employment?',
      type: 'select',
      format: 'capitalize',
    },
    {
      name: 'average_monthly_income',
      label: 'Approximately how much is your average monthly income (BSD)?',
      type: 'currency',
      icon: 'text-$',
    },
    {
      name: 'internet_access',
      label: 'What type of internet do you have access to for training?',
      type: 'select',
      format: 'capitalize',
    },
    {
      name: 'devices_for_training',
      label: 'What device(s) do you have access to for training?',
      type: 'select',
      format: 'capitalize',
    },
    {
      name: 'educational_background',
      label: 'Education Background: Please select all the levels of education you have done in your life',
      type: 'select',
      format: 'capitalize',
    },
    {
      name: 'declarations',
      label: 'Declarations',
      type: 'heading',
    },
    {
      name: 'accept_completion_commitment',
      type: 'checkbox',
      label: 'I have checked the course duration and time commitment, and I am willing and able to complete it.',
    },
    {
      name: 'accept_data_consent',
      type: 'checkbox',
      label: `I understand I own my data at all times. I consent to the use of data for limited essential purposes, 
        such as to confirm eligibility, process my application, and to track outcomes.`,
    },
    {
      name: 'accept_start_date_commitment',
      type: 'checkbox',
      label: `I commit to starting my selected course within two (2) weeks of being accepted into the programme and having access to the course.`,
    }
  ]

  return (
    <Fragment>
      <Switch>
        <Service
          path='upskill-bahamas'
          service='upskill bahamas'
          element={UpskillBahamas}
        />

      </Switch>
      <section className='content minister-applications-table'>
        <Loader loading={loading} />
        <article className='page-inner p-4'>
          <header className='flex justify-between items-center mb-6'>
            <h1 className='text-4xl text-gray-800'>
              Ministry of Education
            </h1>
            <nav className='flex justify-end space-x-4'>
              {/* <span
                onClick={() => setModal([MODAL.MODE])}
                className='flex space-x-1 items-center text-blue-700 cursor-pointer'
              >
                <i className='fas fa-ban'></i>
                <span>Cancel/Revoke</span>
              </span> */}
              <Link
                to='/logout'
                className='flex space-x-1 items-center text-blue-700'
              >
                <i className='fas fa-sign-out-alt'></i>
                <span>Sign Out</span>
              </Link>
            </nav>
          </header>
          <div className='card'>
            <div className='card-header flex flex-col xl:flex-row justify-between items-center'>
              <label className='flex items-center space-x-2'>
                <span className='font-semibold'>Service</span>
                <select
                  name='service'
                  value={service?.key}
                  onChange={changeService}
                  className='form-control'
                >
                  <option value=''>Select A Service</option>
                  {Object.entries(SERVICES).map(([key, { label }]) => (
                    <option key={key} value={key} children={label} />
                  ))}
                </select>
              </label>
              {service?.key == 'UPSKILL_BAHAMAS' && (
                <aside className='flex space-x-4 actions'>
                  <span onClick={() => setDateModal(!showDateModal)}>
                    Filter by Date Range
                  </span>
                </aside>
              )}
              {service?.key == 'UPSKILL_BAHAMAS' && (
                <aside className='flex space-x-4 actions'>
                  <span onClick={filterStatus()}>
                    Filter by Status
                  </span>
                </aside>
              )}
              {service?.key == 'UPSKILL_BAHAMAS' && (
                <aside className='flex space-x-4 actions'>
                  <span onClick={filterIsland()}>
                    Filter by Island
                  </span>
                </aside>
              )}
              {service?.key == 'UPSKILL_BAHAMAS' && (
                <aside className='flex space-x-4 actions'>
                  <span onClick={approve(selected?.length ? selected : data)}>
                    Approve {selected.length ? 'Selected' : 'All'}
                  </span>
                  <span onClick={deny(selected)}>
                    Deny {selected.length ? 'Selected' : 'All'}
                  </span>
                </aside>
              )}
            </div>
            <div className='card-body'>
              {(!formSelected && service) && (
                <div className='table-responsive form-records-table'>
                  <DataTable
                    data={data}
                    columns={columns}
                    onSelectedRowsChange={s => setSelected(s.selectedRows)}
                    clearSelectedRows={clear}
                    conditionalRowStyles={colors}
                    noHeader
                    selectableRows
                    pagination
                    paginationServer
                    paginationPerPage={params.per_page}
                    paginationTotalRows={params.no_of_records}
                    paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 1000]}
                    onChangeRowsPerPage={per_page => setParams({ per_page, page: 1 })}
                    onChangePage={page => setParams({ page })}
                  />
                </div>
              )}
              {(!formSelected && !service) && (
                <div className='py-10 text-center font-semibold'>
                  Please select a service
                </div>
              )}
              {formSelected && (
                <BatchFormView
                  passedProps={{service, formSelected}}
                  setFormSelected={setFormSelected}
                  methods={[{label: 'Approve', fn: approve}, {label: 'Deny',fn: deny}, {label: 'View Notes',fn: setActive}, {label: 'Write Note', fn: writeNote}]}
                  allFields={allFields}
                />
              )}
              {csvDownloaderMenu}
            </div>
          </div>
        </article>
        <ApplicationNotes
          data={active?.notes}
          onClose={() => setActive(null)}
        />
      </section>
      <Modal
        open={modal[0] === MODAL.MODE}
        onClose={() => setModal(false)}
        center
      >
        <header className='modal-header'>
          <h4>Cancel/Suspend A Licence</h4>
        </header>
        <article className='modal-body flex flex-col space-y-6'>
          <button
            className='btn btn-primary'
            onClick={() => getLicenceID('revoke')}
          >Cancel Via Licence Number</button>
          <button
            className='btn btn-primary'
            onClick={() => getLicenceID('suspend')}
          >Suspend Via Licence Number</button>
          <button
            className='btn btn-primary'
            onClick={() => setModal([MODAL.VIA_QR_CODE, 'revoke'])}
          >Cancel Via QR Code</button>
          <button
            className='btn btn-primary'
            onClick={() => setModal([MODAL.VIA_QR_CODE, 'suspend'])}
          >Suspend Via QR Code</button>
        </article>
        <footer className='modal-footer flex justify-end'>
          <button className='btn btn-muted' onClick={() => setModal([])}>
            Close
          </button>
        </footer>
      </Modal>
      <Modal
        open={modal[0] === MODAL.VIA_QR_CODE}
        onClose={() => setModal(false)}
        center
      >
        <p className='text-center my-8'>
          Please scan the QR Code of the licence you wish to {modal[1]}
        </p>
        <div className='relative rounded-xl bg-black overflow-hidden w-full sm:w-96 mx-auto'>
          <QrReader
            delay={1000}
            onScan={getLicenceViaQRCode}
            onError={showScanErrorMessage}
            style={{ width: '100%', height: '100%' }}
          />
          <FaChevronLeft
            size={28}
            color='#FFF'
            className='absolute bottom-0 left-0 mb-2 ml-2 cursor-pointer z-10'
            onClick={() => history.goBack()}
          />
        </div>
      </Modal>
      <Modal
        open={showDateModal}
        onClose={() => setDateModal(false)}
        center
      >
        <header className='modal-header'>
          <h4>Date Filter</h4>
        </header>
        <article className='modal-body flex flex-col space-y-6'>
          <div className='flex'>
            <label htmlFor="startDate">Start Date:</label>
            <input type="date" id="startDate" name="startDate" className='ml-2 rounded-sm' onChange={e => setStartDate(e.target.value)}/>
          </div>

          <div className='flex'>
            <label htmlFor="endDate">End Date:</label>
            <input type="date" id="endDate" name="endDate" className='ml-2 rounded-sm' onChange={e => setEndDate(e.target.value)}/>
          </div>
        </article>
        <footer className='modal-footer flex justify-end'>
          <button className='btn btn-muted' onClick={() => setDateModal(false)}>
            Close
          </button>
          <button className='btn btn-primary' onClick={filterDate()}>
            Filter
          </button>
        </footer>
      </Modal>
    </Fragment>
  )
}

export default UpSkillBatchApprovals
